export default __webpack_public_path__ + "static/media/RLcarriers.5368727b.png";